import React from 'react';

import { ScrollArea, ScrollAreaProps } from '@mantine/core';

interface TabPanelWrapperProps extends ScrollAreaProps {
  children: React.ReactNode;
}

export function TabPanelWrapper({ children, ...scrollAreaProps }: TabPanelWrapperProps) {
  return (
    <ScrollArea h="100%" {...scrollAreaProps}>
      {children}
    </ScrollArea>
  );
}
